var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6439 12.8375L17.1174 9.30452H13.5844V7.0281C13.5844 6.42712 13.6936 6.00826 13.8939 5.7533C14.1671 5.44371 14.6588 5.2798 15.3144 5.2798H17.2084V2.0746C16.4617 2.00175 15.5512 1.96533 14.4585 1.96533C13.0926 1.96533 11.9817 2.36598 11.1258 3.18549C10.2881 3.9868 9.85102 5.15232 9.85102 6.66387V9.30452H6.7915V12.8375H9.85102V22.0343H13.5479V12.8375H16.6439Z"
  })));
};
export default SvgIconFacebook;